import {
  getDeliveryRouteStops,
  getRouteDetail,
} from '../../../selectors/route';
import { lockRoute } from '../../../reducers/route';
import {
  processParcelTransfer,
  processStopTransfer,
  updateTransferEntities,
  validateStopParcels,
} from './transferTo';

const processStop = (stop, condition) => async (dispatch) => {
  const { parcel = [] } = stop;
  if (parcel.every(condition)) {
    return stop;
  }
  const stopFromAPI = await dispatch(
    validateStopParcels(
      parcel
        .filter(condition)
        .map((el) => ({ parcelCode: el.parcelCode, routeDate: el.routeDate }))
    )
  );
  return stopFromAPI ? { ...stop, ...stopFromAPI } : null;
};

export const getAffectedStops =
  (selectedRemoveOption = {}) =>
  async (dispatch, getState) => {
    const state = getState();
    const stops = getDeliveryRouteStops(state);
    const { condition } = selectedRemoveOption;

    return await stops.reduce(async (affected, stop) => {
      try {
        const { parcel = [] } = stop;
        if (parcel.some(condition)) {
          const preparedStop = await dispatch(processStop(stop, condition));
          const acc = await affected;
          if (!preparedStop) {
            throw new Error('Failed to validate stop');
          }
          return [...acc, preparedStop];
        }
        return affected;
      } catch {
        return [];
      }
    }, Promise.resolve([]));
  };

export const onMove =
  (transferRouteId, selectedRemoveOption) => async (dispatch, getState) => {
    const currentUserLock = await dispatch(lockRoute());

    if (!currentUserLock) {
      return false;
    }
    const state = getState();
    const stops = getDeliveryRouteStops(state);
    const currentRoute = getRouteDetail(state);

    const { condition } = selectedRemoveOption;
    const processedStops = stops.filter((stop) => {
      const { parcel = [] } = stop;
      return parcel.some(condition);
    });

    const dataToUpdate = await processedStops.reduce(
      async (processedData, stop, index) => {
        let data = await processedData;
        const { parcel = [] } = stop;
        const processFunction = parcel.every(condition)
          ? processStopTransfer
          : processParcelTransfer;
        const additionalData =
          index === 0
            ? { stop, parcels: parcel.filter(condition) }
            : {
                stop,
                parcels: parcel.filter(condition),
                routeStops: data.updatedStops,
                transferredRouteStops: data.transferredStop,
              };
        const { updatedStops, requests, transferredStop } = await dispatch(
          processFunction(transferRouteId, currentRoute, additionalData)
        );
        return {
          updatedStops,
          requests: [...data.requests, ...requests],
          transferredStop,
        };
      },
      Promise.resolve({ updatedStops: [], requests: [], transferredStop: [] })
    );
    return await dispatch(
      updateTransferEntities({
        ...dataToUpdate,
        transferRouteId,
      })
    );
  };

export const removeParcelsActionCreators = {
  onMove,
  getAffectedStops,
};
